import React, { useEffect, useState, useRef } from 'react'
import MarkerImg from 'assets/icons/marker.png'
import NoImage from 'assets/images/no-image.jpg'
import PropTypes from 'prop-types'
import ResizeImage from 'utils/resizeImage'
import { Map, Marker, GoogleApiWrapper, InfoWindow } from 'google-maps-react'

const API_KEY = process.env.GEO_API_KEY_FE

const SearchMap = ({ lat, lng, zoom = 16, google, data, onMapMove, containerStyle = {}, handleBoundsChange }) => {
  const [selected, setSelected] = useState({})
  const [showInfoWindow, setShowInfoWindow] = useState(false)
  const [activeMarker, setActiveMarker] = useState({})

  const gMap = useRef(null)
  useEffect(() => {
    gMap.current.map.addListener('zoom_changed', () => {
      handleBoundsChange && handleBoundsChange(gMap.current.map.getBounds()
        .toJSON())
    })
  }, [])

  useEffect(() => {
    gMap.current.map.setCenter({ lat, lng })
  }, [lat, lng])

  function handleOnCenterChanged() {
    const center = gMap.current.map.getCenter()
    handleBoundsChange && handleBoundsChange(gMap.current.map.getBounds()
      .toJSON())
    onMapMove(center.lat(), center.lng())
  }

  return (
    <Map
      containerStyle={containerStyle}
      ref={gMap}
      google={google}
      zoom={zoom}
      fullscreenControl={false}
      zoomControlOptions={{ position: google.maps.ControlPosition.TOP_LEFT }}
      streetViewControl={false}
      mapTypeControlOptions={{
        position: google.maps.ControlPosition.TOP_CENTER
      }}
      onDragend={handleOnCenterChanged}
      initialCenter={{
        lat,
        lng,
      }}
      onClick={(e) => {
        console.log(e);
        setSelected({})
        setShowInfoWindow(false)
      }}
    >
      {data.map(value => {
        const { lat, lng } = value.coordinates
        return (
          <Marker
            key={value.id}
            title={value.title}
            options={{
              icon: {
                url: MarkerImg,
                anchor: new google.maps.Point(32, 32),
                scaledSize: new google.maps.Size(64, 64),
              },
              scrollwheel: false,
              zoom: 13,
            }}
            position={{ lat, lng }}
            onClick={(props, marker) => {
              setActiveMarker(marker)
              setSelected(value)
              setShowInfoWindow(true)
            }}
          />
        )
      })}
      <InfoWindow marker={activeMarker} visible={showInfoWindow}>
        <div>
          <a
            className="text-sm hover:text-primary-orange"
            href={selected.url}
            rel="noopener noreferrer"
            target="_blank">
            {selected.title}
          </a>
          <img
            className="w-full mt-3 h-40 object-cover"
            src={selected.images?.length ? ResizeImage(selected.images[0].path, { w: 300 }) : NoImage}
            alt={selected.imageAlt}
          />
        </div>
      </InfoWindow>
    </Map>
  )
}

SearchMap.propTypes = {
  lat: PropTypes.number.isRequired,
  lng: PropTypes.number.isRequired,
  zoom: PropTypes.number,
  google: PropTypes.object.isRequired,
  onMapMove: PropTypes.func.isRequired,
  data: PropTypes.array,
  containerStyle: PropTypes.object,
  handleBoundsChange: PropTypes.func
}

export default GoogleApiWrapper({
  apiKey: API_KEY,
  v: '3',
})(SearchMap)
